import React, { createContext, useContext } from "react";
import { CollapseItem } from "./item";
import "./index.less";

interface CollapseContextValue {
  activeKeys: string[];
  accordion: boolean;
  onItemToggle: (key: string) => void;
}

const CollapseContext = createContext<CollapseContextValue | null>(null);

export const useCollapseContext = () => {
  const context = useContext(CollapseContext);
  if (!context) {
    throw new Error("Collapse.Item must be used within a Collapse");
  }
  return context;
};

interface CollapseProps {
  activeKeys: string[];
  onChange?: (keys: string[]) => void;
  /** 是否为手风琴模式 */
  accordion?: boolean;
  children: React.ReactNode;
}

const Collapse: React.FC<CollapseProps> & { Item: typeof CollapseItem } = ({ activeKeys, onChange, accordion = false, children }) => {
  const onItemToggle = (key: string) => {
    const index = activeKeys.indexOf(key);
    let nextKeys = [...activeKeys];

    if (index > -1) {
      nextKeys.splice(index, 1);
    } else {
      nextKeys = accordion ? [key] : [...nextKeys, key];
    }

    onChange?.(nextKeys);
  };

  return (
    <CollapseContext.Provider value={{ activeKeys, accordion, onItemToggle }}>
      <div className="collapse-group">{children}</div>
    </CollapseContext.Provider>
  );
};

Collapse.Item = CollapseItem;

export default Collapse;